import clsx from "clsx";

import styles from "./TogglePill.module.scss";

type TogglePillProps = {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
};

const TogglePill = ({
  label,
  checked,
  onChange,
  disabled,
}: TogglePillProps) => (
  <label
    className={clsx(
      styles.pill,
      checked && styles.checked,
      disabled && styles.disabled,
    )}
  >
    <input
      type="checkbox"
      checked={checked}
      disabled={disabled}
      onChange={(e) => onChange(e.currentTarget.checked)}
    />
    {label}
  </label>
);

export default TogglePill;
